module.exports = __webpack_public_path__ + "a8f02a267ef7b4c9ff80759b3b0cee58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5412.png
// module id = 112
// module chunks = 1